function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgFlagMa = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 32",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "#d80027",
    d: "M0 .028V32h48V.028z"
  }), ___EmotionJSX("path", {
    fill: "#20661b",
    d: "M33.666 13.932h-6.858L24.684 7.41l-2.124 6.522h-6.858l5.549 4.033-2.124 6.522 5.549-4.033 5.549 4.033-2.105-6.522 5.549-4.033zM22.802 17.46l.72-2.208h2.32l.72 2.208-1.881 1.366L22.8 17.46zm2.611-3.528h-1.46l.73-2.246.73 2.246zm2.274 2.714l-.449-1.394h2.367l-1.918 1.394zm-5.549-1.395l-.449 1.394-1.918-1.394h2.367zm-.496 5.783l.73-2.246 1.179.861-1.909 1.385zm4.164-1.394l1.179-.861.73 2.246-1.909-1.385z"
  }));
});
export default SvgFlagMa;